import React, { useEffect } from 'react';

/**
 * Check if user click outside of the element
 * @param callback - function to call when clicked outside of the ref
 * @param ref - ref to check for click outside (created by useRef Hook  )
 * @param active - boolean to check if the ref is active - if multiple same refs are used, this should be set to false when the ref is not active
 */

const useOutsideCheck = (
  callback: () => void,
  ref: React.RefObject<HTMLDivElement>,
  active: boolean
): void => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (event: any) => {
      event.stopPropagation();
      if (ref.current && !ref.current.contains(event.target) && active) {
        callback();
      }
    };

    if (active) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, callback]);
};

export default useOutsideCheck;
